module.exports = __webpack_public_path__ + "media/stylesheets/images/userway_logo_images/icee-fee9fca08e9fa65e7a92b53c60b03284.png";